// src/features/dashboard/components/Sidebar.js
import React from "react";
import {
  LayoutDashboard,
  Users,
  Settings,
  ChevronLeft,
  ChevronRight,
  Package,
  Pill,
  FlaskConical,
  Cog,
  Truck,
  Presentation,
  Building,
  Notebook,
} from "lucide-react";

import NavMenu from "./NavMenu";

const Sidebar = ({ open, toggleSidebar }) => {
  const menuItems = [
    { path: "/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { path: "/patients", icon: Users, label: "Patients" },

    {
      label: "Inventory",
      icon: Package,
      children: [
        // { path: "/inventory/stock-movements", label: "Stock Movements" },
        { path: "/stock", label: "Medicines List" },
        { path: "/inventory/issue-medicines", label: "Issue Medicines" },
        { path: "/inventory/purchase-medicines", label: "Purchase Medicines" },
      ],
    },

    

    {
      label: "Clinical",
      icon: Pill,
      children: [
        { path: "/clinical/workflow", label: "Visit" },
        { path: "clinical/patients/register", label: "Patient Registration" },
        { path: "clinical/prescriptions/new", label: "Prescribe" },
      ],
    },

    {
      label: "Reports",
      icon: Notebook,
      children: [
        { path: "/reports", label: "Report Dashboard" },
        { path: "/reports/issue", label: "Issue Report " },
        { path: "/reports/stock", label: "Stock Availability" },
        { path: "/reports/low-stock", label: "Low Stock Alert" },
        { path: "/reports/expiry", label: "Stock Expiry" },
        { path: "/reports/movement", label: "Stock Movement" },
        { path: "/reports/top-consumed", label: "Top Consumed Medicines" },
      ],
    },


    {
      label: "Master Data",
      icon: Cog,
      children: [
                { path: '/master/categories', icon: Package, label: 'Stock Categories' },
                { path: '/master/medicines', icon: Users, label: 'Medicines' },
                { path: '/master/units', icon: Presentation, label: 'Units of Measure' },
                { path: '/master/suppliers', icon: Truck, label: 'Suppliers' },
                { path: '/master/locations', icon: Location, label: 'Locations' },
                { path: '/master/manufacturers', icon: Building, label: 'Manufacturers' },
                { path: '/master/departments', icon: Users, label: 'Departments' },
      ],
      divider:true
    },

    { path: "/settings", icon: Settings, label: "Settings", divider: true },



  ];

  return (
    <aside
      className={`fixed left-0 top-16 h-full bg-white shadow-lg transition-all duration-300 ${
        open ? "w-64" : "w-20"
      }`}
    >
      <nav className="h-full overflow-y-auto py-4">
        <NavMenu items={menuItems} open={open} />
      </nav>

      {/* Toggle Button */}
      <button
        className="absolute -right-3 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-1 shadow-md border border-gray-200"
        onClick={toggleSidebar}
      >
        {open ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
      </button>
    </aside>
  );
};

export default Sidebar;